<template>
<div class="chapter">
<div class="inner_page">
<p class="center" id="dedication" style="margin-top:30%;"><span><i>For Staughton and Lynd and Maryam L.</i></span></p>
<p class="center"><span><i>and for John Lewis the unsung.</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 3-dedication.vue?0fc2771c